import color from "color";
import DefaultTheme from "./LightTheme";
// import { black, white, pinkA100 } from "./colors";

const DarkTheme = {
  ...DefaultTheme,
  dark: true,
  roundness: 24,
  colors: {
    primary: "#FFC708",
    accent: "#0772BA",
    background: "#424242",
    surface: "#121212",
    success: "#007600",
    error: "#CF6679",
    onSurface: "#FFFFFF",
    text: "#FFF",
    disabled: color("#FFF").alpha(0.38).rgb().string(),
    placeholder: color("#000").alpha(0.54).rgb().string(),
    backdrop: color("#000").alpha(0.5).rgb().string(),
    notification: "#FAFAFA",
    backgroundForm: color("#000").alpha(0.65).rgb().string(),
    select: "#F5F8FA",
    divider: "#CFDCE5",
    colorRadio: "#D81221",
    deselect: "rgba(224, 223, 223, 1)",
    whiteText: "#FFF",
    blackText: "#000",
    warning: "#e6983a",
  },
};

export default DarkTheme;
